export const orderParser = (order) => {
	if (typeof order.pickupAddress === 'string') {
		order.pickupAddress = JSON.parse(order.pickupAddress)
	}
	if (typeof order.recipientAddress === 'string') {
		order.recipientAddress = JSON.parse(order.recipientAddress)
	}
	return order
}
